"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const component_1 = require("../component");
exports.default = new class NamespaceComponent extends component_1.default {
    defaultOptions = { background: "magenta", bold: true, padding: 0, before: "", after: " " };
    get(opts, printer) {
        const ns = printer.options.namespaceValue;
        return ns ? opts.before + ns + opts.after : "";
    }
    ;
};
